import { PersonalInfo } from '@pu/models';

export interface AuthState {
  profile: PersonalInfo;
  recoveryCodes: string[];
  is2faEnabled: boolean;
}
